import Auth from '../../modules/Authentication'
import { apiUrl } from '../../variables/index'
import { handleErrors, handleResponse } from '../../modules/Utils'

const headers = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
}
export default class Lenders {
  constructor() {
    this.auth = new Auth()
  }

  create = (member) => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}lenders/`, {
      headers: headers,
      method: 'POST',
      body: JSON.stringify(member),
    }).then(handleErrors)
  }
  list = () => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}lenders/`, { headers }).then(handleErrors).then(handleResponse)
  }
  get = (key) => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}lenders/${key}`, { headers }).then(handleErrors)
  }
  getMember = (key) => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}lenders/${key}/member`, { headers }).then(handleErrors).then(handleResponse)
  }
  update = (data) => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}lenders/`, {
      headers: headers,
      method: 'PATCH',
      body: JSON.stringify(data),
    }).then(handleErrors)
  }

  permissions = {
    list: (key, org) => {
      headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
      return fetch(`${apiUrl}lenders/${key}/permissions/${org}`, {
        headers,
      }).then(handleErrors)
    },
    update: (key, org, data) => {
      headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
      return fetch(`${apiUrl}lenders/${key}/permissions/${org}`, {
        headers: headers,
        method: 'PATCH',
        body: JSON.stringify(data),
      }).then(handleErrors)
    },
  }
  contracts = {
    list: (key) => {
      headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
      return fetch(`${apiUrl}lenders/${key}/contracts/`, { headers }).then(handleErrors).then(handleResponse)
    },
    create: (contracts) => {
      headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
      return fetch(`${apiUrl}lenderContracts/`, {
        headers: headers,
        method: 'POST',
        body: JSON.stringify(contracts),
      }).then(handleErrors)
    },
    update: (data) => {
      headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
      return fetch(`${apiUrl}lenderContracts/`, {
        headers: headers,
        method: 'PATCH',
        body: JSON.stringify(data),
      }).then(handleErrors)
    },
    operation: ({status: operation, ...data}) => {
      console.log(2222, {operation, data})
      headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
      return fetch(`${apiUrl}lenderContracts/${operation}`, {
        headers: headers,
        method: 'POST',
        body: JSON.stringify(data),
      })
        .then(handleErrors)
        .then(handleResponse)
    },
  }
  requisitions = {
    list: () => {
      headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
      return fetch(`${apiUrl}labourreqs/`, { headers }).then(handleErrors).then(handleResponse)
    },
  }
  files = {
    list: (key) => {
      headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
      return fetch(`${apiUrl}lenders/${key}/files/`, { headers }).then(handleErrors).then(handleResponse)
    },
  }
  entitlements = {
    get: (key) => {
      headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
      return fetch(`${apiUrl}lenders/${key}/entitlements/`, { headers }).then(handleErrors).then(handleResponse)
    },
  }
}
